import yup from "utils/formSchemas/common";
export const valueAddedTaxSchema = yup.object({}).shape({
    vatType: yup
        .string()
        .nullable()
        .label('VAT Type')
        .required('Select VAT Type')
})